import styled from 'styled-components'
import { BREAK_POINT_MD, BREAK_POINT_SM } from '@CSSVars/variables'

export const _FilterSection = styled.section`
  padding: ${({ isForSideBar }) => (isForSideBar ? '0 24' : '0 0 0 24')}px;
  margin-bottom: 32px;
  max-width: 624px;
  width: 100%;
  display: flex;
  flex-direction: ${({ forMobile, isForSideBar }) => (isForSideBar || forMobile ? 'column' : 'row')};
  label span {
    color: initial !important;
    padding: 0 5px;
  }
  @media screen and (max-width: 1280px) {
    flex-direction: column;
    padding: 0 24px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column;
    padding: 0;
  }
  @media screen and (max-width: ${BREAK_POINT_SM}) {
    padding: 0;
  }
`

export const _FilterTitle = styled.div`
  display: flex;
  align-items: center;
  min-width: calc(188px - 24px);
  font-size:14px;
  line-height: 22px;
  font-weight: 600;
  color: inherit;
  height: ${({ forSideBar }) => (forSideBar ? 'initial' : '36px')};
  ${({ forSideBar }) => (forSideBar && 'margin-bottom: 12px;')};
  @media screen and (max-width: 1280px) {
    height: initial;
    margin-bottom: 12px;
  }
`

export const _ChildrenContainer = styled.div`
  width: 100%;
  flex-direction: column;
  ${({ row }) => (row && `
    display: flex;
    flex-direction: row;
    width: calc(100% + 12px);
    max-width: 475px;
    > div {
      flex: 1;
    }

  `)}
`
